<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Loan & Contributions Info</h3>
           </template>
           <nav class="row">
              <ol class="breadcrumb arr-right bg-breadcrum">
                 <li class="breadcrumb-item">
                    <a href="#" @click="$router.push('/')"><i class="fa fa-home"></i>&nbsp;Dashboard</a>
                 </li>
                   <li class="breadcrumb-item">
                        <router-link to="/hr/contributions/list">Loan & Contributions List</router-link>
                    </li>
                 <li class="breadcrumb-item active">Loan & Contributions Info</li>
              </ol>
           </nav>
           <hr style="margin-top:-10px"/>
           <div class="report-container">
                 <table border="1" width="100%" class="p-table">
                    <tr>
                       <th colspan="4">
                          <h4>
                             <center>Blueprint Business Solutions BPO Corporation</center>
                          </h4>
                       </th>
                    </tr>
                    <tr>
                       <th colspan="4">
                          <p>
                          <center>4F Norkis Cyberpark, A.S. Fortuna St. Bakilid, Mandaue City, Cebu</center>
                          </p>
                       </th>
                    </tr>
                    <tr>
                        <td><b>&nbsp;&nbsp;Employee Name:</b></td>
                        <td colspan="4"><b>{{item.full_name}}</b></td>

                    </tr>
                    <tr>
                        <td><b>&nbsp;&nbsp;ID Number:</b></td>
                        <td align="right">{{item.emp_id}}</td>
                        <td><b>&nbsp;&nbsp;Date Covered:</b></td>
                        <td align="right">{{getDate(item.created_at)}}</td>
                     </tr>
                    <tr>
                        <td><b>&nbsp;&nbsp;TIN:</b></td>
                        <td align="right"> {{item.tin_no}}</td>
                        <td><b>&nbsp;&nbsp;Department:</b></td>
                        <td>{{item.department_name}}</td>
                    </tr>
                    <tr>
                        <td><b>&nbsp;&nbsp;PHIC Number:</b></td>
                        <td align="right">{{item.phic_no}}</td>
                        <td><b>&nbsp;&nbsp;Position:</b></td>
                        <td>{{item.position_name}}</td>
                    </tr>
                    <tr>
                        <td><b>&nbsp;&nbsp;HDMF Number:</b></td>
                        <td align="right">{{item.hdmf_no}}</td>
                    </tr>
                     <tr>
                       <td colspan="4"><br/></td>
                    </tr>
                    <tr>
                       <td  colspan="4"><b>&nbsp;&nbsp;LOAN AND CONTRIBUTIONS</b></td>
                    </tr>
                    <tr>
                       <td colspan="4"><br/></td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;SSS Contributions</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.sss_cont}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;PHIC Contributions</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.phic_cont}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;HDMF/PAG-IBIG Contributions</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.hdmf_pagibig_cont}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;HMO</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.hmo}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;SSS Loan</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.sss_loan}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;HDMF/PAG-IBIG Loan</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.hdmf_loan}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;Wihtholding Tax</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.withholding_tax}}</td>
                    </tr>
                    <tr>
                        <td>&nbsp;&nbsp;Others</td>
                        <td colspan="4" align="right">&nbsp;&nbsp;{{item.others}}</td>
                    </tr>
                 </table>
              <!-- </div> -->
           </div>
        </card>
     </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
        components: {
            Card,
        },
        
        data(){
            return{
                item:{}
            }
        },
        
        created:function(){
            this.getItem()
        },

    
        methods:{
            getItem(){
              axios.get('api/contributions/'  + this.$route.params.id + '/' + this.$route.params.employee_id)
                    .then(resp => 
                      {
                         console.log('response => detailts:',resp) 
                         this.item = resp.data
                      }
                   );
            },
    
        },
    
    }
    </script>

    
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contributions/todo-contributions-details.vue